<template>
  <CardOrder
    :orders="filteredOrders"
    @edit-order="editItem"
    :tables="allTables"
  />
</template>

<script>
import CardOrder from "@/components/card-dashboard/card-order/CardOrder.vue";
import { mapGetters } from "vuex";

export default {
  name: "ListOrder",
  props: {
    orders: {
      type: Object,
      default: null,
    },
    orderType: {
      type: String,
      default: null,
    },
    searchOrder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      selectedOrder: null,
    };
  },
  components: {
    CardOrder,
  },
  computed: {
    ...mapGetters("tables", ["allTables"]),
    ...mapGetters("sales_orders", ["allSalesOrders"]),
    ...mapGetters("cash_registers", ["allCashRegisters"]),
    relevantCashRegister() {
      return this.allCashRegisters?.find((cr) => !cr.time_end);
    },
    filteredOrders() {
      this.allSalesOrders.map((so) => {
        so.table = this.allTables?.find((table) => table.id === so.table_id);
      });
      console.log(this.allSalesOrders);
      let notAllowedStatus = ["canceled", "paid"];
      if (!this.allSalesOrders) return [];
      let filtered = this.allSalesOrders.filter(
        (so) => !notAllowedStatus.includes(so.status)
      );
      if (this.orderType)
        filtered = filtered.filter(
          (so) => so.order_type === this.orderType
        );

      if (this.searchOrder)
        filtered = filtered.filter(
          (transaksi) =>
            transaksi?.table?.name.toUpperCase().indexOf(this.searchOrder.toUpperCase()) > -1 ||
            transaksi?.customer_name.toUpperCase().indexOf(this.searchOrder.toUpperCase()) > -1 ||
            transaksi?.code.toUpperCase().indexOf(this.searchOrder.toUpperCase()) > -1
        );
      return filtered;
    },
  },
  created() {
    // this.$store.dispatch("tables/fetchTables");
    // this.$store.dispatch("cash_registers/fetchCashRegisters");
    // if (this.relevantCashRegister) {
    //   this.$store.dispatch("sales_orders/fetchSalesOrders", {
    //     cash_register_id: this.relevantCashRegister.id,
    //   });
    // }
  },
  methods: {
    async editItem(item) {
      this.selectedOrder = item;
      const path = this.$router.resolve({
        name: 'order',
        query: { orderId: item.id }
      }).href;
      window.open(path, '_self');
    },
    getRelevantTable(order) {
      return this.allTables?.find((table) => table.id === order.table_id);
    },
  },
};
</script>
